import React from "react"
import { Router, Route } from "react-router-dom"
import { Provider } from "react-redux"

import { apolloClient } from "@/state/apollo-client"
import { ApolloProvider } from "@apollo/client"

import { ErrorBoundary } from "@/components/common/error-boundary"
import App from "@/components"
import { store } from "@/state/redux-store"
import history from "@/utils/history"

// Kept out of the entry (index.tsx): a module that defines components gets a react-refresh
// self-import, and on the entry that loads a second copy of the app once HMR has touched it
export const AppRoot = () => (
	<ErrorBoundary>
		<ApolloProvider client={apolloClient}>
			{/*
			//@ts-ignore: assume this is because store isn't TS but not sure.. */}
			<Provider store={store}>
				<Router history={history}>
					<Route path="*" component={App} />
				</Router>
			</Provider>
		</ApolloProvider>
	</ErrorBoundary>
)
